import { Components } from '@mui/material';

export default {
  styleOverrides: {
    root: {
      margin: 0,
    },
  },
} as Components;
